"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SearchLocationForm } from "./form-with-location";
import { useSearchNavigation } from "./hooks";
import type { SearchSectionProps } from "./types";
export const SearchSection: React.FC<SearchSectionProps> = t0 => {
  const $ = _c(10);
  const {
    className: t1,
    isLoggedIn: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const isLoggedIn = t2 === undefined ? false : t2;
  const {
    isLoading,
    isPending,
    setIsNavigating,
    handleSearchWithFallback,
    handleSearchWithCoordinates
  } = useSearchNavigation();
  let t3;
  let t4;
  if ($[0] !== isPending || $[1] !== setIsNavigating) {
    t3 = () => {
      if (!isPending) {
        setIsNavigating(false);
      }
    };
    t4 = [isPending, setIsNavigating];
    $[0] = isPending;
    $[1] = setIsNavigating;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  React.useEffect(t3, t4);
  let t5;
  if ($[4] !== className || $[5] !== handleSearchWithCoordinates || $[6] !== handleSearchWithFallback || $[7] !== isLoading || $[8] !== isLoggedIn) {
    t5 = <SearchLocationForm className={className} onSearchWithFallback={handleSearchWithFallback} onSearchWithCoords={handleSearchWithCoordinates} isLoading={isLoading} isLoggedIn={isLoggedIn} />;
    $[4] = className;
    $[5] = handleSearchWithCoordinates;
    $[6] = handleSearchWithFallback;
    $[7] = isLoading;
    $[8] = isLoggedIn;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};

// Export types and utilities for external use
export type { PlaceDetails, SearchSectionProps } from "./types";